<template>
  <div>
    <h6
      v-if="siteData === null"
      class="heading-small text-muted mb-4 text-truncate"
    >
      Add Site
    </h6>
    <h6 v-else class="heading-small text-muted mb-4 text-truncate">
      Edit Site
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input v-model="formData.name" :disabled="viewMode" />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Code" required>
              <a-input v-model="$v.formData.code.$model" :disabled="viewMode" />
              <div v-if="$v.formData.code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.code.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Area">
              <a-input v-model="formData.area" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Address">
              <a-input v-model="formData.address" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Contact Person">
              <a-input v-model="formData.contact_person" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Email">
              <a-input
                v-model="$v.formData.email.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.email.email">
                  Invalid email format.
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Contact Number">
              <a-input v-model="formData.contact_no" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="siteData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createSite"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="editSite"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';

export default {
  name: 'SiteForm',
  props: {
    siteData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      formData: {
        code: null,
        name: null,
        area: null,
        address: null,
        contact_person: null,
        email: null,
        contact_no: null
      }
    };
  },

  validations: {
    formData: {
      name: { required },
      code: { required },
      email: { email }
    }
  },

  methods: {
    async createSite() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest('/api/v1/sites', {
          site: this.formData
        });

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    async editSite() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/sites/' + this.siteData.id,
          {
            site: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },
    clearForm() {
      this.formData.code = null;
      this.formData.name = null;
      this.formData.area = null;
      this.formData.address = null;
      this.formData.contact_person = null;
      this.formData.email = null;
      this.formData.contact_no = null;
    },
    setFormData() {
      if (this.siteData !== null) {
        const { code, area, name, address, contact_person, email, contact_no } =
          this.siteData;

        this.formData.code = code;
        this.formData.name = name;
        this.formData.area = area;
        this.formData.address = address;
        this.formData.contact_person = contact_person;
        this.formData.email = email;
        this.formData.contact_no = contact_no;
      }
    }
  },
  created() {
    this.setFormData();
  },
  watch: {
    siteData: function (newVal) {
      if (newVal !== null) {
        this.setFormData();
      } else {
        this.clearForm();
      }
    },

    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  }
};
</script>

<style scoped></style>
